import { render, staticRenderFns } from "./SelectorIllustration.vue?vue&type=template&id=53475902&"
import script from "./SelectorIllustration.vue?vue&type=script&lang=js&"
export * from "./SelectorIllustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53475902')) {
      api.createRecord('53475902', component.options)
    } else {
      api.reload('53475902', component.options)
    }
    module.hot.accept("./SelectorIllustration.vue?vue&type=template&id=53475902&", function () {
      api.rerender('53475902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectorIllustration.vue"
export default component.exports